import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from "./styles.module.scss";

export default function logo(showMenu) {
  if (!showMenu) {
    return <img alt="SuperSim logo" src="/image/logo.png" className={styles.logoImage} />;
  }

  return (
    <NavLink to="/">
      <img alt="SuperSim logo" src="/image/logo.png" className={styles.logoImage} />
    </NavLink>
  );
}
